import React from 'react';
import { Card, CardContent, Badge } from '@roger/ui-components';
import type { WorksheetIntervention } from '../../types/worksheetGoals.types';
import InstructionDisplay from '../InstructionDisplay';

interface InterventionItemProps {
  intervention: WorksheetIntervention;
}

const InterventionItem: React.FC<InterventionItemProps> = ({
  intervention,
}) => {
  return (
    <Card className='bg-gray-50'>
      <CardContent className='p-4'>
        <div className='space-y-2'>
          {/* Intervention Name and Status */}
          <div className='flex items-start justify-between gap-2'>
            <div className='font-medium text-sm text-gray-900 flex-1'>
              {intervention.intervention_name || 'Unnamed Intervention'}
            </div>
            <Badge
              variant={intervention.active ? 'default' : 'secondary'}
              className='text-xs'
            >
              {intervention.active ? 'Active' : 'Inactive'}
            </Badge>
          </div>

          {/* Instruction */}
          {intervention.instruction && (
            <InstructionDisplay
              instruction={intervention.instruction}
              className='text-gray-700'
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default InterventionItem;
